// eslint-disable-next-line @typescript-eslint/ban-types
function isObject(it) {
    // This is necessary because:
    // typeof null === 'object'
    // typeof [] === 'object'
    // [] instanceof Object === true
    return Object.prototype.toString.call(it) === '[object Object]';
}
/**
 * Demo:
 * inputObj = {
 *   a1: 'a1',
 *   b1: { b2: true },
 *   deep: {
 *     c2: { d3: { test: 'test' }, e3: { f4: { g5: { test: 'deeeeep' } } } },
 *   },
 *   arr: [1, 2, 3],
 * };
 *
 * toFlatPropertyMap(inputObj) == {
 *   "a1": "a1",
 *   "b1.b2": true,
 *   "deep.c2.d3.test": "test",
 *   "deep.c2.e3.f4.g5.test": "deeeeep",
 *   "deep.deep.a1": "a1",
 *   "arr": [
 *       1,
 *       2,
 *       3
 *   ]
 * }
 *
 * toFlatPropertyMap(inputObj, { maxDepth: 4 }) == {
 *   "a1": "a1",
 *   "b1.b2": true,
 *   "deep.c2.d3.test": "test",
 *   "deep.c2.e3.f4": {
 *       "g5": {
 *           "test": "deeeeep"
 *       }
 *   },
 *   "arr": [
 *       1,
 *       2,
 *       3
 *   ]
 * }
 *  @param inputObj
 * @param keySeparator
 * @returns
 */
export function toFlatPropertyMap(inputObj, options) {
    const { keySeparator = '.', maxDepth } = options || {};
    const flattenRecursive = (obj, propertyMap, depth = 1, parentKey) => {
        for (const [key, value] of Object.entries(obj)) {
            const path = parentKey ? `${parentKey}${keySeparator}${key}` : key;
            const currentDepth = depth + 1;
            if (value && isObject(value) && (!maxDepth || currentDepth <= maxDepth)) {
                flattenRecursive(value, propertyMap, currentDepth, path);
            }
            else {
                propertyMap[path] = value;
            }
        }
        return propertyMap;
    };
    const result = {};
    return flattenRecursive(inputObj, result);
}
